import { useParams } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { Suspense, useState } from 'react'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Row,
  Space,
  theme,
  Typography,
} from 'antd'
import { errorResponse } from '../../lib/errorResponse'
import { gutter } from '../../lib/layout'
import { LoadingAnimation } from '../LoadingAnimation'
import { FileInputFormItem } from './FileInputFormItem'
import { FilePdfOutlined } from '@ant-design/icons'

export function StepUploadAdditionalDocuments({
  onboarding,
  sessionToken,
  goToNext,
  goToNextText,
  goToPrevious,
}) {
  const { companyUid } = useParams()
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const { token } = theme.useToken()

  async function onSubmit() {
    setLoading(true)
    try {
      goToNext()
    } catch (e) {
      errorResponse(e)
    } finally {
      setLoading(false)
    }
  }

  async function uploading(upload) {
    setLoading(upload)
  }

  const [form] = Form.useForm()

  return (
    <Form form={form} layout="vertical" onFinish={onSubmit}>
      <Row gutter={gutter}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                fontSize: token.fontSize,
                paddingContentHorizontal: token.paddingContentHorizontal,
                controlHeight: token.controlHeight,
                borderRadius: token.borderRadius,
              },
            },
          }}
        >
          <Col span={24}>
            <Typography.Paragraph>
              <Trans
                i18nKey="frontend:onboarding.additionalDocumentsUploadDescription"
                components={{ strong: <strong /> }}
                values={{ companyName: onboarding.company.name }}
              />
            </Typography.Paragraph>
          </Col>
          <Col span={24}>
            <Suspense fallback={<LoadingAnimation />}>
              <FileInputFormItem
                required={false}
                buttonText={
                  <Space>
                    <FilePdfOutlined />
                    <span>
                      {t('frontend:onboarding.additionalDocumentsChooseFile')}
                    </span>
                  </Space>
                }
                name={['fileList']}
                parentPath={`onboarding/${companyUid}/additionalDocuments/`}
                //accept={['.pdf', '.csv', '.xls', '.xlsx', '.txt']}
                maxCount={20}
                setLoading={uploading}
                sessionToken={sessionToken}
              />
            </Suspense>
          </Col>
        </ConfigProvider>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Space>
            <Button type="text" onClick={() => goToPrevious()}>
              {t('frontend:common.back')}
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {goToNextText}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  )
}
